import { useContext, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";

import styles from "./Sidebar.module.css";
import i18n from "../Services/i18n";
import Footer from "./Footer";
import { AuthContext } from "../AuthProvider/AuthProvider";

import logo from "../Assets/EL2610LogoWeb.png";
import logoMark from "../Assets/EL2610LogoSeul.png";
import mediaLibIcon from "../Assets/Icons/medialib_black2.png";
import dashboardIcon from "../Assets/Icons/dashboard_white.png";
import clientIcon from "../Assets/Icons/client_black.png";
import horseIcon from "../Assets/Icons/horse_black.png";
import serviceIcon from "../Assets/Icons/service_black.png";
import myAccountIcon from "../Assets/Icons/myaccount.png";
import logOut from "../Assets/Icons/logout.png";
import calendarIcon from "../Assets/Icons/calendar.png";

function Sidebar() {
  const location = useLocation();
  const { logout } = useContext(AuthContext);

  const [isCollapsed, setIsCollapsed] = useState(() => {
    return localStorage.getItem("sidebarCollapsed") === "true";
  });

  const toggleSidebar = () => {
    setIsCollapsed((previousValue) => {
      const newValue = !previousValue;

      localStorage.setItem("sidebarCollapsed", newValue.toString());

      return newValue;
    });
  };

  const menuItems = [
    {
      path: "/dashboard",
      icon: dashboardIcon,
      label: i18n.t("SideBar.MenuDashboard"),
    },
    {
      path: "/clients",
      icon: clientIcon,
      label: i18n.t("SideBar.MenuClients"),
    },
    {
      path: "/horses",
      icon: horseIcon,
      label: i18n.t("SideBar.MenuHorses"),
    },
    {
      path: "/userservices",
      icon: serviceIcon,
      label: i18n.t("SideBar.MenuMyServices"),
    },
    {
      path: "/calendar",
      icon: calendarIcon,
      label: i18n.t("SideBar.MenuCalendar"),
    },
    {
      path: "/mediatheque",
      icon: mediaLibIcon,
      label: i18n.t("SideBar.MenuMediatheque"),
    },
  ];

  return (
    <div className={`${styles.sidebar} ${isCollapsed ? styles.collapsed : ""}`}>
      <div className={styles.logoContainer}>
        <img src={logo} alt="Equestrolog" className={`${styles.logoFull} ${styles.logoImage}`} />

        <img src={logoMark} alt="" className={`${styles.logoMark} ${styles.logoImage}`} />
      </div>

      <button
        type="button"
        className={styles.toggleButton}
        onClick={toggleSidebar}
        title={isCollapsed ? i18n.t("SideBar.Expand") : i18n.t("SideBar.Collapse")}>
        {isCollapsed ? <MdChevronRight /> : <MdChevronLeft />}
      </button>

      <nav>
        <ul className={styles.navList}>
          {menuItems.map((item) => (
            <li
              key={item.path}
              className={styles.navItem}
              title={isCollapsed ? item.label : undefined}>
              <NavLink
                to={item.path}
                className={`${styles.navLink} ${
                  location.pathname === item.path ? styles.activeLink : ""
                }`}>
                <img src={item.icon} alt="" className={styles.navicon} />

                <span className={styles.label}>{item.label}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      <div className={styles.bottomItems}>
        <div
          className={styles.navItemBottom}
          title={isCollapsed ? i18n.t("SideBar.MenuMyAccount") : undefined}>
          <NavLink
            className={`${styles.navLink} ${
              location.pathname === "/myaccount" ? styles.activeLink : ""
            }`}
            to="/myaccount">
            <img src={myAccountIcon} alt="" className={styles.navicon} />

            <span className={styles.label}>{i18n.t("SideBar.MenuMyAccount")}</span>
          </NavLink>
        </div>

        <div
          className={styles.navItemBottom}
          title={isCollapsed ? i18n.t("SideBar.MenuLogout") : undefined}>
          <button
            type="button"
            className={`${styles.navLink} ${styles.logoutButton}`}
            onClick={logout}>
            <img src={logOut} alt="" className={styles.navicon} />

            <span className={styles.label}>{i18n.t("SideBar.MenuLogout")}</span>
          </button>
        </div>
      </div>

      {!isCollapsed && <Footer />}
    </div>
  );
}

export default Sidebar;
